export function getMeetLink(id = '') {
    return `/meets/${id}`
}
